import { z } from "zod";

/**
 * Phase 98 — QS-Bericht: Coverage + Auffälligkeiten der Pipeline-Run.
 * Wird vom qs-agent geschrieben. Im MVP nur Basis-Counters.
 */
export const QsAmpelSchema = z.enum(["gruen", "gelb", "rot"]);
export type QsAmpel = z.infer<typeof QsAmpelSchema>;

export const QsSchema = z.object({
  schemaVersion: z.literal(1).default(1),
  ampel: QsAmpelSchema,
  positionenGesamt: z.number().int().nonnegative(),
  positionenMitMatch: z.number().int().nonnegative(),
  positionenBepreisbar: z.number().int().nonnegative(),
  klaerpunkteOffen: z.number().int().nonnegative(),
  hinweise: z.array(z.string()).default([]),
});

export type Qs = z.infer<typeof QsSchema>;
